import React from 'react';
import { FadeIn } from './FadeIn';
import { ActivityIcon, HeartPulseIcon, BrainIcon, FlameIcon, AlertTriangleIcon, MoonIcon, WindIcon, ZapOffIcon } from 'lucide-react';
export function NewProblem() {
  const symptoms = [{
    icon: <ActivityIcon className="w-6 h-6 text-peach" data-id="element-422" />,
    title: 'Síntomas Digestivos',
    subtitle: 'ENDO-BELLY',
    items: [{
      text: 'Gases excesivos después de comer',
      icon: <FlameIcon className="w-4 h-4 text-peach" data-id="element-423" />
    }, {
      text: 'Alternancia de estreñimiento y diarrea',
      icon: <ActivityIcon className="w-4 h-4 text-peach" data-id="element-424" />
    }, {
      text: 'Pesadez incluso con alimentos saludables',
      icon: <AlertTriangleIcon className="w-4 h-4 text-peach" data-id="element-425" />
    }]
  }, {
    icon: <HeartPulseIcon className="w-6 h-6 text-peach" data-id="element-426" />,
    title: 'Síntomas Pélvicos',
    subtitle: 'DOLOR CRÓNICO',
    items: [{
      text: 'Calambres que no ceden con analgésicos',
      icon: <HeartPulseIcon className="w-4 h-4 text-peach" data-id="element-427" />
    }, {
      text: 'Dolor durante relaciones sexuales',
      icon: <AlertTriangleIcon className="w-4 h-4 text-peach" data-id="element-428" />
    }, {
      text: 'Molestias punzantes en fase lútea',
      icon: <FlameIcon className="w-4 h-4 text-peach" data-id="element-429" />
    }]
  }, {
    icon: <BrainIcon className="w-6 h-6 text-peach" data-id="element-430" />,
    title: 'Síntomas Sistémicos',
    subtitle: 'CUERPO AGOTADO',
    items: [{
      text: 'Fatiga crónica sin esfuerzo previo',
      icon: <MoonIcon className="w-4 h-4 text-peach" data-id="element-431" />
    }, {
      text: 'Irritabilidad y cambios de humor cíclicos',
      icon: <BrainIcon className="w-4 h-4 text-peach" data-id="element-432" />
    }, {
      text: 'Niebla mental y falta de concentración',
      icon: <WindIcon className="w-4 h-4 text-peach" data-id="element-433" />
    }]
  }];
  return <section className="py-12 md:py-24 bg-forest" data-id="element-434">
      <FadeIn className="container mx-auto px-5 max-w-[1200px]" data-id="element-435">
        <div className="max-w-3xl mb-10 md:mb-16" data-id="element-436">
          <span className="text-peach text-xs font-bold tracking-[0.2em] uppercase mb-3 md:mb-4 block" data-id="element-437">
            ¿Te reconoces?
          </span>
          <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl text-cream mb-4 md:mb-6 leading-tight" data-id="element-438">
            El dolor que cargas{' '}
            <span className="italic text-peach" data-id="element-439">no es normal</span>.<br data-id="element-440" />
            Es una señal.
          </h2>
          <p className="text-sand text-lg md:text-xl leading-relaxed" data-id="element-441">
            El Endodolor no se limita a una sola zona. Afecta la digestión, la
            pelvis y todo el sistema simultáneamente. ¿Cuántos de estos síntomas
            reconoces?
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-442">
          {symptoms.map((group, idx) => <div key={idx} className="bg-forest border border-cream/10 rounded-2xl p-6 md:p-8 hover:border-cream/20 transition-colors shadow-lg" data-id="element-443">
              <div className="mb-5 md:mb-6" data-id="element-444">{group.icon}</div>
              <h3 className="font-serif text-2xl text-cream mb-1" data-id="element-445">
                {group.title}
              </h3>
              <div className="text-peach/70 text-xs tracking-widest uppercase mb-8" data-id="element-446">
                {group.subtitle}
              </div>

              <ul className="space-y-4" data-id="element-447">
                {group.items.map((item, i) => <li key={i} className="flex items-start gap-3 text-sand text-sm" data-id="element-448">
                    <div className="bg-peach/10 p-1.5 rounded-md shrink-0 mt-0.5" data-id="element-449">
                      {item.icon}
                    </div>
                    <span className="leading-relaxed" data-id="element-450">{item.text}</span>
                  </li>)}
              </ul>
            </div>)}
        </div>

        <div className="bg-[#3a2522] border-l-4 border-peach rounded-r-xl rounded-l-sm p-6 md:p-8 max-w-full flex flex-col md:flex-row gap-6 items-start" data-id="element-451">
          <AlertTriangleIcon className="w-8 h-8 text-peach shrink-0 mt-1" data-id="element-452" />
          <div data-id="element-453">
            <h4 className="font-serif text-2xl text-cream mb-3" data-id="element-454">
              Si marcas más del 50% de estos síntomas...
            </h4>
            <p className="text-sand/90 leading-relaxed" data-id="element-455">
              Tu cuerpo te está pidiendo a gritos un cambio de combustible. El
              dolor que te incapacita no es un rasgo femenino inevitable: es
              inflamación que sí se puede revertir.
            </p>
          </div>
        </div>
      </FadeIn>
    </section>;
}